import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import { FreeMode,Pagination,Autoplay } from 'swiper/modules';
import ReactStars from "react-rating-stars-component";
import { apiConnector } from '../../services/apiconnector';
import { ratingsEndpoints } from '../../services/apis';
import { MdOutlineStarPurple500 } from "react-icons/md";
import { MdOutlineStarHalf } from "react-icons/md";
import { MdOutlineStarBorderPurple500 } from "react-icons/md";

function ReviewSlider(props) {

    const [reviews,setReviews] = useState([]);
    const wordLength = 15;

    useEffect(()=>{
        async function fetchAllReviews()
        { 
            // const response = await apiConnector("GET",ratingsEndpoints.REVIEWS_DETAILS_API);
            // console.log("Response: ",response);

            const {data} = await apiConnector("GET",ratingsEndpoints.REVIEWS_DETAILS_API);

            if(data?.success)
            {
                // console.log("Hi",data?.data)
                
                setReviews(data?.data);
            }

            // console.log("Response1: ",reviews)
        }
        fetchAllReviews();
    },[])

    return (
        <div className='text-white w-full'>
            <div className='h-[190px] w-screen max-w-maxContent'>
                {/* hello */}
                <Swiper
                    slidesPerView={4}
                    spaceBetween={24}
                    loop={true}
                    freeMode={true}
                    autoplay={{
                        delay: 2500
                    }}
                    modules={[FreeMode,Pagination,Autoplay]}
                    className='w-full'
                >
                    {
                        reviews.length > 0 && (
                            reviews.map((review,index)=>{
                                return (
                                    <SwiperSlide key={index} className='bg-richblack-800 max-[450px]:hidden p-5 flex flex-col gap-1'>
                                        <div className=''>
                                            <div className='flex gap-x-2 items-center'>
                                                <img src={review?.user?.image ? (review?.user?.image) : (`https://api.dicebear.com/5.x/initials/svg?seed=${review?.user?.firstName} ${review?.user?.lastName}`)} alt="" className='h-9 w-9 object-cover rounded-full'/>
                                                <div>
                                                    <p className='text-richblack-5'>{review?.user?.firstName} {review?.user?.lastName}</p>
                                                    <p className='text-richblack-50'>{review?.course?.courseName}</p>
                                                </div>
                                            </div>
                                            <div>
                                            </div>
                                                {review?.review.split(" ") > wordLength ? (`${review?.review.split(" ").slice(0,15).join(" ")}....`) : (`${review?.review}`)}
                                            <div className='flex gap-x-2 items-center'>
                                                <p className='text-yellow-25'>{review?.rating.toFixed(1)}</p>
                                                {/* <p className=''>{review?.rating}</p> */}
                                                <ReactStars
                                                count={5}
                                                value={review?.rating.toFixed(1)}
                                                size={20}
                                                edit={false}
                                                activeColor={"#ffd700"}
                                                emptyIcon={<MdOutlineStarPurple500 />}
                                                halfIcon={<MdOutlineStarHalf />}
                                                fullIcon={<MdOutlineStarBorderPurple500 />}
                                                />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        )
                    }
                </Swiper>
            </div>
        </div>
    );
}

export default ReviewSlider;